// extracted by mini-css-extract-plugin
export default {"productGrid":"b2-z","centerLink":"c2-z","productSection":"d2-z","item":"e2-z","ctaButton":"f2-z"};